/* eslint-disable react/no-danger */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useRef } from 'react';

import useClickOutside from '../../hooks/useClickOutside';
import useKeyboardKeys, { KEYS } from '../../hooks/useKeyboardKeys';

import IntersectingVideo from '../blocks/employee/IntersectingVideo';
import CloseButton from '../buttons/Close';

import styles from '../../../styles/modals/timeline-modal.module.scss';

const propTypes = {
    title: PropTypes.string,
    text: PropTypes.string,
    image: PropTypes.string,
    video: PropTypes.string,
    layoutType: PropTypes.string,
    color: PropTypes.string,
    backgroundColor: PropTypes.string,
    onClose: PropTypes.func.isRequired,
    visible: PropTypes.bool.isRequired,
    className: PropTypes.string,
};

const defaultProps = {
    title: null,
    text: null,
    image: null,
    video: null,
    layoutType: null,
    color: null,
    backgroundColor: null,
    className: null,
};

const TimelineModal = ({
    title,
    text,
    image,
    video,
    layoutType,
    color,
    backgroundColor,
    className,
    onClose,
    visible,
}) => {
    const ref = useRef(null);

    useKeyboardKeys({
        [KEYS.ESCAPE]: onClose,
    });

    useClickOutside(ref, onClose);

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                    [styles.visible]: visible,
                },
            ])}
        >
            <div
                className={classNames([
                    styles.modalWrap,
                    {
                        [styles[layoutType]]: layoutType,
                    },
                ])}
                style={{ backgroundColor: `${backgroundColor}`, color: `${color}` }}
                ref={ref}
            >
                <CloseButton
                    color={color !== null ? color : '#222'}
                    onClick={onClose}
                    className={styles.closeBtn}
                />
                {layoutType === 'imageRight' && (
                    <div className={styles.modalTypography}>
                        {title !== null ? <h3 className={styles.modalTitle}>{title}</h3> : null}
                        <p
                            className={styles.modalText}
                            dangerouslySetInnerHTML={{ __html: text }}
                        />
                    </div>
                )}
                {image !== null && video === null ? (
                    <div
                        className={classNames([styles.modalMedia], {
                            [styles.larger]: text === null,
                        })}
                    >
                        <img src={image} alt="" />
                    </div>
                ) : null}

                {video !== null ? (
                    <div
                        className={classNames([styles.modalMedia], {
                            [styles.larger]: text === null,
                        })}
                    >
                        <IntersectingVideo src={video} className={styles.video} />
                        {/* <img src={image} alt="" /> */}
                    </div>
                ) : null}

                {layoutType !== 'imageRight' && (
                    <div className={styles.modalTypography}>
                        {title !== null ? <h3 className={styles.modalTitle}>{title}</h3> : null}
                        <p
                            className={styles.modalText}
                            dangerouslySetInnerHTML={{ __html: text }}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

TimelineModal.propTypes = propTypes;
TimelineModal.defaultProps = defaultProps;

export default TimelineModal;
